<jhi-modal [title]="titleKey  | translate" [disabled]="isSaving">
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col">
                <span [translate]="descriptionKey"></span>
            </div>
        </div>
        <div class="container-fluid px-0 pt-3">
            <div class="row mb-2">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">
                    <div class="btn-group">
                        <input type="text" class="form-control form-control-sm" placeholder="{{'search.placeholder' | translate}}" [(ngModel)]="searchQuery">
                        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="searchQuery = ''"><i
                                class="fa fa-times"></i></button>
                    </div>
                </div>
            </div>
            <div class="custom-scroll-style" style="max-height: 350px; overflow-y: auto; overflow-x: hidden;">
                <table class="table table-striped table-bordered table-curved mb-0">
                    <thead class="sticky-header">
                    <tr>
                        <th>
                        </th>
                        <th> {{ 'study-editor.study-dataset.instance-table-selector.trial-instance' | translate }}
                        </th>
                        <th> {{ 'study-editor.study-dataset.instance-table-selector.location-name' | translate }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (instanceModel of studyInstances | filter:searchQuery:'locationName'; track instanceModel.instanceId) {
                            <tr>
                                <td>
                                    <input type="radio" class="form-check-input m-1"
                                           [(ngModel)]="selectedInstanceId" [value]="instanceModel.instanceId" checked>
                                </td>
                                <td>
                                    {{ instanceModel.instanceNumber }}
                                </td>
                                <td>
                                    {{ instanceModel.locationName }}
                                </td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="4" class="text-center text-muted">
                                    <span> {{ 'study-editor.study-dataset.instance-table-selector.empty' | translate }}</span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isSaving">
            <span [translate]="cancelLabelKey"></span>
        </button>
        <button (click)="continue()" class="btn btn-primary" [disabled]="isSaving || !selectedInstanceId">
            <i *ngIf="isSaving" class="throbber throbber-btn"></i>
            <span class="ms-1" [translate]="continueLabelKey"></span>
        </button>
    </div>
</jhi-modal>
